import { jwtDecode } from "jwt-decode";
import useLoginStore from "../taskpane/store/loginStore";
import { requestRefresh } from "../taskpane/services/trustApi";

interface DecodedToken {
  exp: number;
  [key: string]: any;
}

export const refreshIfNeeded = async () => {
  const { vtoken, ttoken, logIn, logOut } = useLoginStore.getState();
  if (!vtoken || !ttoken) return;

  try {
    const decoded: DecodedToken = jwtDecode(vtoken);
    const now = Math.floor(Date.now() / 1000);
    const timeRemaining = decoded.exp - now;

    if (timeRemaining < 172800) {
      // less than 2 days
      const newTokens = await requestRefresh({ ttoken });
      if (newTokens?.isLoggedIn) {
        logIn(newTokens);
      } else {
        logOut();
      }
    }
  } catch (err) {
    console.error("Error decoding/refreshing token", err);
    logOut();
  }
};
